<template>
  <div>
    <div class="labelSynchronization-title">
      {{ $t("LabelConfig.LabelSynchronization.title") }}
    </div>
    <!-- 标签同步 -->
    <Form
      ref="labelSynchronizationForm"
      :model="labelSynchronizationForm"
      :rules="ruleValidate"
      :label-width="120"
    >
      <Row style="margin-bottom: 20px;">
        <Col span="24">
          <Card>
            <div v-if="companyId == 1">
              <Row style="margin-top: 15px;">
                <FormItem
                  :label="$t('LabelConfig.LabelSynchronization.company')"
                  prop="companyId"
                >
                  <Select
                    v-model="labelSynchronizationForm.companyId"
                    @on-change="
                      companyIdChange(labelSynchronizationForm.companyId)
                    "
                    :placeholder="$t('LabelConfig.LabelSynchronization.company')"
                    style="width:300px;"
                  >
                    <Option
                      v-for="item in companyIdList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.companyName }}</Option
                    >
                  </Select>
                </FormItem>
              </Row>
            </div>
            <Row>
              <FormItem
                :label="$t('LabelConfig.LabelSynchronization.account')"
                prop="accountSearchKey"
              >
                <Select
                  v-model="labelSynchronizationForm.accountSearchKey"
                  filterable
                  multiple
                  :max-tag-count="1"
                  :placeholder="$t('LabelConfig.LabelSynchronization.pleaseInputAccount')"
                  :transfer="true"
                  style="width: 300px;"
                  @on-change="
                    changeAccount(labelSynchronizationForm.accountSearchKey)
                  "
                >
                  <Checkbox
                    v-model="singleAccount"
                    @on-change="selectAccountAll"
                    style="display: block;text-align:right;"
                    >{{ $t("alarms.common.allSelected") }}</Checkbox
                  >
                  <Option
                    :value="item.id"
                    v-for="item in accountList"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Row>
            <Row>
              <FormItem :label="$t('LabelConfig.LabelSynchronization.synchronizationType')" prop="synchronizationType">
                <RadioGroup
                  v-model="synchronizationType"
                  @on-change="changeSynchronizationType()"
                >
                  <Radio
                    v-for="item in synchronizationTypeList"
                    :label="item.id"
                    :key="item.id"
                    >{{ item.name }}</Radio
                  >
                </RadioGroup>
              </FormItem>
            </Row>
            <Row>
              <FormItem
                :label="$t('LabelConfig.LabelSynchronization.resourceType')"
                prop="resourceType"
              >
                <Select
                  v-model="labelSynchronizationForm.resourceType"
                  filterable
                  multiple
                  :transfer="true"
                  :max-tag-count="1"
                  style="width:300px;"
                  @on-change="
                    changeResourceType(labelSynchronizationForm.resourceType)
                  "
                >
                  <Checkbox
                    v-model="singleResourceType"
                    @on-change="selectAccountAllResourceType"
                    style="display: block;text-align:right;"
                    >{{ $t("alarms.common.allSelected") }}</Checkbox
                  >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in resourceTypeList"
                    v-bind:key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Row>
            <div v-if="synchronizationType === 0">
              <!-- 附件 -->
              <FormItem
                :label="$t('LabelConfig.LabelSynchronization.attachment')"
                prop="enclosure"
              >
                <Upload
                  ref="upload"
                  v-model="labelSynchronizationForm.enclosure"
                  :on-success="uploadSuccess"
                  :on-error="uploadError"
                  :headers="{ userName: userName }"
                  multiple
                  type="drag"
                  :action="actionUrl"
                  style="width:300px;"
                  :show-upload-list="true"
                  :on-remove="handleRemove"
                >
                  <div>
                    <Icon
                      type="ios-cloud-upload"
                      size="50"
                      style="color: #3399ff"
                    ></Icon>
                    <p>{{ $t("message.uploadFile") }}</p>
                  </div>
                </Upload>
              </FormItem>
              <FormItem label=" ">{{
                $t("LabelConfig.LabelSynchronization.attention")
              }}</FormItem>
            </div>
            <div v-if="synchronizationType === 1">
              <FormItem :label="$t('LabelConfig.LabelSynchronization.tag')" prop="tag">
                <Select
                  v-model="labelSynchronizationForm.tag"
                  filterable
                  :transfer="true"
                  style="width:300px;"
                  @on-change="changeTag()"
                >
                  <Option
                    :value="item.id"
                    v-for="item in tagList"
                    v-bind:key="item.id"
                    >{{ item.keyName }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem :label="$t('LabelConfig.LabelSynchronization.rule')" prop="rule">
                <Select
                  v-model="labelSynchronizationForm.rule"
                  filterable
                  :transfer="true"
                  style="width:300px;"
                >
                  <Option
                    :value="item.id"
                    v-for="item in ruleList"
                    v-bind:key="item.id"
                    >{{ item.ruleName }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem :label="$t('LabelConfig.LabelSynchronization.contact')" prop="contact">
                <Select
                  v-model="labelSynchronizationForm.contact"
                  filterable
                  multiple
                  :max-tag-count="1"
                  :placeholder="$t('LabelConfig.LabelSynchronization.pleaseSelectContact')"
                  :transfer="true"
                  style="width: 300px;"
                  @on-change="changeContact(labelSynchronizationForm.contact)"
                >
                  <Checkbox
                    v-model="singleContact"
                    @on-change="selectAllContact"
                    style="display: block;text-align:right;"
                    >{{ $t("alarms.common.allSelected") }}</Checkbox
                  >
                  <Option
                    :value="item.id"
                    v-for="item in contactList"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </div>
            <Row>
              <FormItem label=" ">
                <Button
                  type="primary"
                  v-hasPermission="[
                    'labelManagement:labelSynchronization:update'
                  ]"
                  @click="updateLabel('labelSynchronizationForm')"
                  >{{
                    $t("LabelConfig.LabelSynchronization.updateTag")
                  }}</Button
                >
                <Button
                  type="primary"
                  v-hasPermission="[
                    'labelManagement:labelSynchronization:sync'
                  ]"
                  @click="syncLabel('labelSynchronizationForm')"
                  >{{
                    $t("LabelConfig.LabelSynchronization.synchronizingTag")
                  }}</Button
                >
              </FormItem>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
import {
  setCookie,
  getCookie,
  delCookie
} from "../../../../utils/cookieUtil.js";
export default {
  name: "LabelSynchronization",
  data() {
    return {
      tagList: "",
      ruleList: "",
      contactList: "",
      singleContact: false,
      companyId: getCookie(global.companyId),
      id: "",
      attachmentIDs: [],
      userName: getCookie(global.cookieName),
      actionUrl: "", //附件
      companyIdList: [], //公司
      singleAccount: false,
      accountList: [], //账号
      singleResourceType: false,
      synchronizationType: 0,
      synchronizationTypeList: [
        {
          id: 0,
          name: this.$t('LabelConfig.LabelSynchronization.fileSync')
        },
        {
          id: 1,
          name: this.$t('LabelConfig.LabelSynchronization.ruleSync')
        }
      ],
      resourceTypeList: [
        {
          id: 0,
          name: "EC2"
        },
        {
          id: 1,
          name: "RDS"
        }
      ],
      labelSynchronizationForm: {
        companyId: "",
        accountSearchKey: [],
        resourceType: [0, 1],
        tag: "",
        rule: "",
        contact: ""
      },
      ruleValidate: {
        companyId: [
          {
            required: true,
            message: this.$t('tag.pleaseSelectCompany'),
            trigger: "change",
            type: "number"
          }
        ],
        accountSearchKey: [
          {
            required: true,
            type: "array",
            message: this.$t('tag.pleaseSelectAccount'),
            trigger: "change"
          }
        ],
        resourceType: [
          {
            required: true,
            message: this.$t('tag.pleaseSelectResourceType'),
            trigger: "change",
            type: "array"
          }
        ],
        tag: [
          {
            required: true,
            message: this.$t('LabelConfig.LabelSynchronization.pleaseSelectTag'),
            trigger: "change",
            type: "number"
          }
        ],
        rule: [
          {
            required: true,
            message: this.$t('LabelConfig.LabelSynchronization.pleaseSelectRule'),
            trigger: "change",
            type: "number"
          }
        ],
        contact: [
          {
            required: true,
            message: this.$t('LabelConfig.LabelSynchronization.pleaseSelectContact'),
            trigger: "change",
            type: "array"
          }
        ]
      }
    };
  },
  mounted: function() {
    // 上传附件接口
    this.actionUrl = process.env.API_ROOT + "/sme/file/uploadFileS3";
    // companyId:1（silverlining用户）
    if (this.companyId == 1) {
      this.listRegisterInformation();
    } else {
      this.labelSynchronizationForm.companyId = this.companyId;
      this.getAWSAccountByCompanyId();
    }
    this.changeSynchronizationType();
    this.getStandardTagDropDownBox();
    this.selectContactListByCompanyId();
  },
  methods: {
    // 切换标签
    changeTag: function() {
      if (this.StringUtils.isNotEmpty(this.labelSynchronizationForm.tag)) {
        this.$api.standardTagRule
          .queryRuleGroupByTagKeyId(
            "standardTagKeyId",
            this.labelSynchronizationForm.tag
          )
          .then(res => {
            this.ruleList = res.data;
            if (this.StringUtils.isNotEmpty(this.ruleList)) {
              this.labelSynchronizationForm.rule = this.ruleList[0].id;
            }
          });
      }
    },
    // 获取标准标签下拉框
    getStandardTagDropDownBox: function() {
      this.$api.tag.getStandardTagList().then(res => {
        this.tagList = res.data;
      });
    },
    // 获取联系人
    selectContactListByCompanyId: function() {
      if (
        this.StringUtils.isNotEmpty(this.labelSynchronizationForm.companyId)
      ) {
        this.$api.contact
          .selectContactListByCompanyId(
            "companyId",
            this.labelSynchronizationForm.companyId
          )
          .then(res => {
            this.contactList = res.data;
          });
      }
    },
    // 切换同步类型
    changeSynchronizationType: function() {
      if (this.synchronizationType === 0) {
        this.resourceTypeList = [
          {
            id: 0,
            name: "EC2"
          },
          {
            id: 1,
            name: "RDS"
          }
        ];
        this.selectAccountAllResourceType();
      } else {
        this.labelSynchronizationForm.resourceType = 0;
        this.resourceTypeList = [
          {
            id: 0,
            name: "EC2"
          }
        ];
      }
    },
    // 附件
    /****************************************************/
    // 上传成功
    uploadSuccess(res, file, fileList) {
      this.$Message.success(this.$t('common.uploadSuccess'));
      this.attachmentIDs.push(file.response.id);
      this.id = file.response.id;
    },
    // 上传失败
    uploadError(error, file) {
      //上传失败
      this.$Message.error(this.$t('common.uploadFail'));
    },
    // 删除附件
    handleRemove(file, fileList) {
      this.$api.file.deleteAttatchment("id", file.response.id).then(res => {
        this.$Message.success(this.$t('common.deleteSuccess'));
        this.attachmentIDs = [];
        for (var i = 0; i < fileList.length; i++) {
          this.attachmentIDs.push(fileList[i].response.id);
        }
      });
    },
    /******************公司***********************/
    // 公司
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.labelSynchronizationForm.companyId = this.companyIdList[0].id;
        }
        this.labelSynchronizationForm.accountSearchKey = [];
        // 查询的当前公司下的账号列表
        this.getAWSAccountByCompanyId();
        this.selectContactListByCompanyId();
      });
    },
    // 切换公司
    companyIdChange: function() {
      this.labelSynchronizationForm.accountSearchKey = [];
      this.getAWSAccountByCompanyId();
      this.selectContactListByCompanyId();
    },
    /******************账号***********************/
    // 切换账户
    changeAccount: function(val) {
      if (val.length === this.accountList.length && val.length !== 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    // 切换联系人
    changeContact: function(val) {
      if (val.length === this.contactList.length && val.length !== 0) {
        this.singleContact = true;
      } else {
        this.singleContact = false;
      }
    },
    // 账号
    getAWSAccountByCompanyId: function() {
      this.$api.account
        .getAWSAccountByCompanyId(
          "companyId",
          this.labelSynchronizationForm.companyId
        )
        .then(res => {
          this.accountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (var i = 0; i < this.accountList.length; i++) {
              this.labelSynchronizationForm.accountSearchKey.push(
                this.accountList[i].id
              );
            }
          }
        });
    },
    selectAccountAll() {
      this.labelSynchronizationForm.accountSearchKey = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.labelSynchronizationForm.accountSearchKey.push(item.id);
        });
      } else {
        this.labelSynchronizationForm.accountSearchKey = [];
      }
    },
    // 全选联系人
    selectAllContact() {
      this.labelSynchronizationForm.contact = [];
      if (this.singleContact) {
        this.contactList.map(item => {
          this.labelSynchronizationForm.contact.push(item.id);
        });
      } else {
        this.labelSynchronizationForm.contactList = [];
      }
    },
    /******************资源类型***********************/
    // 切换资源类型
    changeResourceType: function(val) {
      if (val.length === this.resourceTypeList.length && val.length != 0) {
        this.singleResourceType = true;
      } else {
        this.singleResourceType = false;
      }
    },
    // 资源类型
    selectAccountAllResourceType: function() {
      this.labelSynchronizationForm.resourceType = [];
      if (this.singleResourceType) {
        this.resourceTypeList.map(item => {
          this.labelSynchronizationForm.resourceType.push(item.id);
        });
      } else {
        this.labelSynchronizationForm.resourceType = [];
      }
    },
    // 更新标签
    updateLabel: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.tag
            .exportTags({
              companyId: this.labelSynchronizationForm.companyId,
              accountIds: this.labelSynchronizationForm.accountSearchKey,
              resourceTypes: this.labelSynchronizationForm.resourceType
            })
            .then(res => {
              let fileName = this.$t('LabelConfig.LabelSynchronization.exportFileName');
              let blob = new Blob([res.data], { type: "application/x-xls" });
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(link.href);
              }
              this.loading = false;
              this.$Message.destroy();
              this.$Message.success(this.$t('common.exportSuccess'));
            });
        }
      });
    },
    // 同步标签
    syncLabel: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            type: this.synchronizationType
          };
          if (this.synchronizationType === 0) {
            params.id = this.id;
          } else {
            params.standardTagRuleId = this.labelSynchronizationForm.rule;
            params.accountIds = this.labelSynchronizationForm.accountSearchKey;
            params.contactIdList = this.labelSynchronizationForm.contact;
          }
          this.$api.tag.synchronizationTags(params).then(res => {
            this.$Message.success(this.$t('LabelConfig.LabelSynchronization.syncTagSuccess'));
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.labelSynchronization-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.title {
  font-size: 14px;
  font-weight: 600;
  float: left;
  color: #000;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/label_synchronization/LabelSynchronization.vue